import { render, staticRenderFns } from "./procedureHadInsure.vue?vue&type=template&id=bdeba76a&scoped=true&"
import script from "./procedureHadInsure.vue?vue&type=script&lang=js&"
export * from "./procedureHadInsure.vue?vue&type=script&lang=js&"
import style0 from "./procedureHadInsure.vue?vue&type=style&index=0&id=bdeba76a&prod&lang=scss&scoped=true&"
import style1 from "./procedureHadInsure.vue?vue&type=style&index=1&id=bdeba76a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeba76a",
  null
  
)

export default component.exports